/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './FooterDisclosures.scss';

import React from 'react';

import Disclosure from 'components/shared/Disclosure/Disclosure';

import Content from 'services/Content';

const FooterDisclosure = ({ name, content }) => (
  <div className="footer-disclosure">
    <div className="footer-disclosure-title">Important Information</div>
    <div className="footer-disclosure-name">{name}</div>
    <Disclosure content={content} />
  </div>
);

const FooterDisclosures = () => (
  <div className="footer-disclosures">
    <FooterDisclosure
      name="Activity Summary"
      content={Content.activitySummaryDisclosure}
    />
    <FooterDisclosure
      name="Portfolio Growth"
      content={Content.portfolioGrowthDisclosure}
    />
    <FooterDisclosure
      name="Personal Rate of Return"
      content={Content.prrPerformanceDisclosure}
    />
  </div>
);

export default FooterDisclosures;
